// import egg from './imgs/egg.png';
// import sandwich from './imgs/sandwich.png';
// import cereal from './imgs/cereal.png';

const data = {
  id: 1,
  title: 'Listen and number',
  subTitle: 'Nghe và đánh số thứ tự nội dung xuất hiện trong bài',
  // audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/963330b6-5116-4ab3-88bd-ccf433b2ecb4.mp3',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/60f5cd0f-06ed-4165-9e47-4927110beb0b.mp3',
  question: '',
  answers: [
    { answer: '1', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Flyers/cereal.png' },
    { answer: '2', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Movers/sandwich.png' },
    { answer: '3', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/fried.png' },
  ],
};

export default data;
